<template id="Cardapio">
  <v-ons-page id="CardapioPage">
    <v-card class="Card_Contain d-flex align-center flex-column">
      <div class="Card_Titulo">
        <h1>Cardápio</h1>
      </div>

      <v-row class="box-alert">
        <v-alert class="text-justify" color="#e6e6e6" dark dense prominent>
          <img
            src="../assets/img/Atencao.svg"
            width="73"
            style="position: absolute; left: -30px; bottom: calc(50% - 36.5px)"
          />
          <div style="margin-left: 35px !important">
            <h1 style="text-transform: none; color: #212226; font-size: 1.1rem; font-weight: bold; text-align: center; margin: 0;">Atenção!</h1>
            <p style="color: #000; text-align: center; font-size: 0.9rem; text-transform: none; line-height: 1rem;">
              Inserir somente imagens nas extensões: jpg, jpeg até 3MB, com no mínimo 600 pixel de largura. <br>
              (Se não ficar com boa leitura aumente o número de pixel da imagem)<br><br>
              Para cardápios com mais de 1 página, fechar o arquivo com todas as imagens das páginas em sequência vertical (uma em baixo da outra)
            </p>
          </div>
        </v-alert>
      </v-row>

      <v-row class="d-flex justify-center" style="margin: 5px 0;">
        <v-button @click="openCardapio()" class="botao" style="margin: 0 !important;">Visualizar Cardápio</v-button>
      </v-row>

      <v-row style="width: 63vw; margin-top: 15px; max-width: 1000px;">
        <v-col>
          <v-row>
            <div class="container">
              <vue-dropzone
                ref="uploadCardapio"
                :include-styling="false"
                :useCustomSlot="true"
                id="dropzone1"
                :uploadMultiple="false"
                :options="dropzoneOptions"
                @vdropzone-file-added="fileCardapioAdded"
              >
                <div class="dropzone-container">
                  <h3>Adicionar Cardápios</h3>
                  <div class="file-selector">
                    Arraste ou clique para adicionar seus cardápios
                    <p class="separator">
                      <span>ou</span>
                    </p>
                    <v-button type="button" class="botao">Procure aqui</v-button>
                  </div>
                </div>
              </vue-dropzone>
            </div>
          </v-row>
          <v-row>
            <div class="container">
              <div class="card-dashed">
                <h3>Upload Vídeo Cardápios</h3>
                <p>(Usar links do youtube ou vimeo)</p>
                <v-text-field
                  v-model="cardapioVideo"
                  outlined
                  label="Link vídeo"
                  prepend-inner-icon="mdi-video-plus-outline"
                  append-outer-icon="mdi-send"
                  @click:append-outer="saveVideo(1)"
                  @keyup.enter.native="saveVideo(1)"
                ></v-text-field>
              </div>
            </div>
          </v-row>
        </v-col>
        <v-col>
          <v-row>
            <div class="container">
              <vue-dropzone
                ref="uploadPromocoes"
                :include-styling="false"
                :useCustomSlot="true"
                id="dropzone"
                :uploadMultiple="false"
                :options="dropzoneOptions"
                @vdropzone-file-added="filePromocaoAdded"
              >
                <div class="dropzone-container">
                  <h3>Adicionar Promoções</h3>
                  <div class="file-selector">
                    Arraste ou clique para adicionar suas promoçōes
                    <p class="separator">
                      <span>ou</span>
                    </p>
                    <v-button type="button" class="botao">Procure aqui</v-button>
                  </div>
                </div>
              </vue-dropzone>
            </div>
          </v-row>
          <v-row>
            <div class="container">
              <div class="card-dashed">
                <h3>Upload Vídeo Promoçōes</h3>
                <p>(Usar links do youtube ou vimeo)</p>
                <v-text-field
                  v-model="promocaoVideo"
                  outlined
                  label="Link vídeo"
                  prepend-inner-icon="mdi-video-plus-outline"
                  append-outer-icon="mdi-send"
                  @click:append-outer="saveVideo(2)"
                  @keyup.enter.native="saveVideo(2)"
                ></v-text-field>
              </div>
            </div>
          </v-row>
        </v-col>
      </v-row>
      
      <v-row>
        <v-col>
          <h2 class="titulo" style="text-transform: none">Cardápios</h2>
          <ListaAnexos :attachments="getCardapioAttachments" :deleteFile="deleteFile" />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h2 class="titulo" style="text-transform: none">Promoções</h2>
          <v-row>
            <ListaAnexos :attachments="getPromocaoAttachments" :deleteFile="deleteFile" />
          </v-row>
        </v-col>
      </v-row>
    
    </v-card>

  <h3 class="copy">Copyright © 2020. Todos os direitos reservados a Cyma Digital. <a class="copy" href="https://qrservice.com.br/termos-de-uso" target="_blank">Leia aqui os Termos e Condições.</a></h3>

  </v-ons-page>
</template>
<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import ListaAnexos from "./Cardapio/ListaAnexos";
import { isObject } from "util";

export default {
  name: "Cardapio",
  key: "Cardapio",
  props: ["pageStack"],
  data() {
    return {
      idEstab: 0,
      cardapio: [],
      file: "",
      imgLogo: "",
      cardapioVideo: "",
      promocaoVideo: "",
      cardapioAttachments: [],
      promocaoAttachments: [],
      attachments: [],
      dropzoneOptions: {
        // The Url Where Dropped or Selected files will be sent
        url: `${this.$menu_uri}/upload-image`,
        counter: 0,
        form: new FormData(),
        // File Size allowed in MB
        maxFilesize: 3000000,
        // The way you want to receive the files in the server
        paramName: function () {
          return "imgBytes";
        },
        dictDefaultMessage: "Adicione suas promoçōes",
        includeStyling: false,
        previewsContainer: false,
        thumbnailWidth: 250,
        thumbnailHeight: 140,
        uploadMultiple: false,
        parallelUploads: 1,
        manuallyAddFile: true,
        autoProcessQueue: false,
        acceptedFiles: "image/jpg,image/jpeg",
      },
    };
  },
  components: {
    vueDropzone: vue2Dropzone,
    ListaAnexos: ListaAnexos,
  },
  computed: {
    getCardapioAttachments() {
      localStorage.setItem('Cardapio', this.cardapioAttachments)
      return this.cardapioAttachments;
    },
    getPromocaoAttachments() {
      return this.promocaoAttachments;
    },
  },
  methods: {
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return [parseFloat((bytes / Math.pow(k, i)).toFixed(dm)), sizes[i]];
    },
    uploadFile(file, type) {
      const fileSize = this.formatBytes(file.size);
      if (file.type !== "image/jpeg" || file.size > 3145728) {
        this.$ons.notification.toast(
          "Inserir somente imagens nas extensões: jpg, jpeg até 3MB, seu arquivo possui " +
            fileSize[0] +
            fileSize[1],
          { timeout: 4000, animation: "ascend" }
        );
        return;
      }

      let attachment = {};
      attachment.title = file.name.split(" ").join("").split(".").join("");
      attachment.extension = "." + file.type.split("/")[1];
      attachment.image = null;
      attachment.size = file.size;
      attachment.dsMedia = "imagem";
      attachment.show = false;
      attachment.dtComeca = null;
      attachment.dtTermina = null;
      attachment.menuComeca = false;
      attachment.menuTermina = false;

      const idEstabelecimento = JSON.parse(localStorage.getItem("e")).idEstabelecimento;
      
      let formData = new FormData();
      let filename = attachment.title.replace(attachment.extension, "");
      if (attachment.extension === ".jpeg") {
        filename = attachment.title.replace(".jpg", "");
      }

      formData.append("imgBytes", file);
      formData.append("intImage", type);
      formData.append("dsMedia", "imagem");
      formData.append("filename", filename);
      formData.append("idEstabelecimento", idEstabelecimento);
      fetch(this.$menu_uri + "/upload-image", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (typeof data === "object") {
            attachment.image = this.$menu_img_uri + data.dsImagem;
            attachment.id = data.idCardapio;
            attachment.dtComeca = data.dtComeca;
            attachment.dtTermina = data.dtTermina;
            attachment.flSegunda = data.flSegunda === "0" ? false : true;
            attachment.flTerca = data.flTerca === "0" ? false : true;
            attachment.flQuarta = data.flQuarta === "0" ? false : true;
            attachment.flQuinta = data.flQuinta === "0" ? false : true;
            attachment.flSexta = data.flSexta === "0" ? false : true;
            attachment.flSabado = data.flSabado === "0" ? false : true;
            attachment.flDomingo = data.flDomingo === "0" ? false : true;
            attachment.dsTipo = data.dsTipo;
            attachment.dsMedia = data.dsMedia;

            if (data.dsTipo === "promocao") {
              this.promocaoAttachments = [
                ...this.promocaoAttachments,
                attachment,
              ];
            } else {
              this.cardapioAttachments = [
                ...this.cardapioAttachments,
                attachment,
              ];
            }
            
            this.$ons.notification.toast("Salvo com sucesso.", {
              timeout: 2000,
              animation: "ascend",
            });
          } else {
            this.$ons.notification.toast(
              "Ocorreu um erro ao salvar, tente novamente.",
              { timeout: 2000, animation: "ascend" }
            );
          }
        })
        .then((error) => {
          if (error) {
            this.$ons.notification.toast(
              "Ocorreu um erro ao salvar, tente novamente.",
              { timeout: 2000, animation: "ascend" }
            );
          }
        });
      
    },
    saveVideo(type) {
      let video;
      if (type === 1 && !this.cardapioVideo) {
        this.$ons.notification.toast("Url inválida.", {
          timeout: 3000,
          animation: "ascend",
        });
        return;
      }
      if (type === 2 && !this.promocaoVideo) {
        this.$ons.notification.toast("Url inválida.", {
          timeout: 3000,
          animation: "ascend",
        });
        return;
      }

      if (this.cardapioVideo) {
        video = this.cardapioVideo;
      } else {
        video = this.promocaoVideo;
      }

      if (!video.includes("youtube") && !video.includes("vimeo")) {
        this.$ons.notification.toast("Url inválida.", {
          timeout: 3000,
          animation: "ascend",
        });
        return;
      }

      let attachment = {};
      attachment.title = video;
      attachment.extension = null;
      attachment.image = video;
      attachment.size = null;
      attachment.dsMedia = "video";
      attachment.show = false;
      attachment.dtComeca = null;
      attachment.dtTermina = null;
      attachment.menuComeca = false;
      attachment.menuTermina = false;

      
      const idEstabelecimento = JSON.parse(localStorage.getItem("e")).idEstabelecimento;

      window.console.log(idEstabelecimento)

      fetch(this.$menu_uri + "/save-video", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          intImage: type,
          dsMedia: "video",
          dsVideo: video,
          idEstabelecimento,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (isObject(data)) {
            attachment.id = data.idCardapio;
            attachment.dtComeca = data.dtComeca;
            attachment.dtTermina = data.dtTermina;

            if (data.dsTipo === "promocao") {
              this.promocaoAttachments = [
                ...this.promocaoAttachments,
                attachment,
              ];
            } else {
              this.cardapioAttachments = [
                ...this.cardapioAttachments,
                attachment,
              ];
            }
            this.cardapioVideo = "";
            this.promocaoVideo = "";
            this.$ons.notification.toast("Salvo com sucesso.", {
              timeout: 2000,
              animation: "ascend",
            });
          } else {
            this.$ons.notification.toast(
              "Ocorreu um erro ao salvar, tente novamente.",
              { timeout: 2000, animation: "ascend" }
            );
          }
        })
        .then((error) => {
          if (error) {
            this.$ons.notification.toast(
              "Ocorreu um erro ao salvar, tente novamente.",
              { timeout: 2000, animation: "ascend" }
            );
          }
        });
    },
    fileCardapioAdded(file) {
      this.uploadFile(file, 1);
    },
    filePromocaoAdded(file) {
      this.uploadFile(file, 2);
    },
    deleteFile(attachment) {
      const idEstab = JSON.parse(localStorage.getItem("e")).idEstabelecimento;

      fetch(`${this.$menu_uri}/cardapio/${idEstab}/${attachment.id}`, {
        method: "DELETE",
      })
        .then((response) => response.json())
        .then((data) => {
          this.updateData(data);
        });
    },
    openCardapio() {
      var w = window.open(
        this.$menu_base + "p/" + btoa(this.idEstab),
        "_blank"
      );
      w.focus();
    },
    updateData(data) {
      this.cardapio = data;

      const promocaoAttachments = [];
      const cardparioAttachments = [];
      for (const item of data) {
        let attachment = {};
        if (item.dsMedia === "video") {
          attachment.title = item.dsVideo;
          attachment.image = item.dsVideo;
        } else {
          attachment.title = item.dsImagem.replace(
            `${item.idEstabelecimento}/`,
            ""
          );
          attachment.extension = ".jpg";
          attachment.image = `${this.$menu_img_uri}${item.dsImagem}`;
        }
        attachment.size = null;
        attachment.show = false;
        attachment.id = item.idCardapio;
        attachment.dtComeca = item.dtComeca;
        attachment.dtTermina = item.dtTermina;
        attachment.flSegunda = item.flSegunda === "0" ? false : true;
        attachment.flTerca = item.flTerca === "0" ? false : true;
        attachment.flQuarta = item.flQuarta === "0" ? false : true;
        attachment.flQuinta = item.flQuinta === "0" ? false : true;
        attachment.flSexta = item.flSexta === "0" ? false : true;
        attachment.flSabado = item.flSabado === "0" ? false : true;
        attachment.flDomingo = item.flDomingo === "0" ? false : true;
        attachment.dsTipo = item.dsTipo;
        attachment.dsMedia = item.dsMedia;
        attachment.dsVideo = item.dsVideo;
        attachment.dsVideoDescricao = item.dsVideoDescricao;
        attachment.menuComeca = false;
        attachment.menuTermina = false;

        if (item.dsTipo === "promocao") {
          promocaoAttachments.push(attachment);
        } else {
          cardparioAttachments.push(attachment);
        }
      }

      this.cardapioAttachments = cardparioAttachments;
      this.promocaoAttachments = promocaoAttachments;
    },
  },
  created() {
    var estab = JSON.parse(localStorage.getItem("e"));
    this.idEstab = estab.idEstabelecimento;
    const idEstab = estab.idEstabelecimento;
    fetch(`${this.$menu_uri}/cardapio/${idEstab}`, { method: "GET" })
      .then((response) => response.json())
      .then((data) => {
        this.updateData(data);
      });
  },
};
</script>
<style scoped>
#CardapioPage {
  margin-left: 256px;
}
.box-alert {
  margin-top: 60px;
  padding: 1rem 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 63vw;
}
.space-x-1-4 {
  padding: 1rem 4rem;
}
.space-x-4 {
  padding: 4rem;
}
.imgLogo {
  width: 90%;
  height: 180px;
  background-image: url("../assets/img/iconLogo.png");
  background-repeat: no-repeat;
  background-position: center;
}
.imgCardapio {
  width: auto;
  height: 400px;
  background-image: url("../assets/img/iconCardapio.png");
  background-repeat: no-repeat;
  background-position: center;
}
h3 {
  color: black;
}
ons-select {
  min-width: 180px;
}
ons-row {
  margin-top: 15px;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.inputfile + label {
  font-size: 1.25em;
  background-color: none;
  display: inline-block;
}
/* 
.inputfile:focus + label, .inputfile + label:hover {
  border:1px solid #000;
} */
.inputfile + label {
  cursor: pointer; /* "hand" cursor */
}
/* .inputfile:focus + label {
outline: 1px dotted #000;
	outline: -webkit-focus-ring-color auto 5px;
} */
.inputfile + label * {
  pointer-events: none;
}
figure {
  margin: 0px;
}
.dropzone-container {
  display: flex;
  flex-direction: column;
  background-color: #e6e6e6;
  border: 1px dashed #ccc;
  border-radius: 15px;
}
.dropzone-container h3 {
  color: #212226;
  text-transform: none;
  font-size: 1.3rem;
}
.file-selector {
  color: #212226;
  padding: 0;
  text-transform: none;
  /* z-index: -9; */
}
.separator {
  position: relative;
}
.separator:after {
  position: absolute;
  content: "";
  height: 2px;
  width: 200px;
  background: #212226;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.file-selector .separator {
  margin: 20px 0 !important;
}
.file-selector .botao {
  margin-top: 0;
  margin-bottom: 20px;
}
.card-dashed {
  display: flex;
  flex-direction: column;
  border: 1px dashed #ccc;
  border-radius: 15px;
  padding: 1rem;
  background-color: #e6e6e6;
}
.card-dashed h3 {
  color: #212226 !important;
  text-transform: none;
  font-size: 1.3rem;
  margin: 0 !important;
}
.card-dashed p {
  color: #212226;
  text-transform: none;
  font-size: 1rem;
}
span {
  position: relative;
  background: #e6e6e6;
  padding: 0 4px;
  z-index: 9;
  font-size: 1rem;
  color: #212226;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
button {
  background: #031629;
  box-shadow: 0 0 2px 0 rgba(3, 22, 41, 0.11),
    0 6px 16px 0 rgba(3, 22, 41, 0.08);
  font-family: SFProDisplay-Regular;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.4px;
  padding: 12px 30px;
  border-radius: 4px;
}
.copy {
  color: #666666;
  font-size: 0.8rem;
  font-family: "DMSans-Regular" !important;
  text-align: center;
  text-transform: none;
}

</style>
